import { jsx } from "panel";
import { SharingStatusButtonEl } from "common/widgets/sharing/status-button";
export function template() {
  return /* @__PURE__ */ jsx(SharingStatusButtonEl, { attrs: {
    elref: "sharingButton",
    id: this.attr("id"),
    "project-id": this.attr("project-id"),
    theme: this.attr("theme"),
    type: this.attr("type"),
    "hide-share-button": this.helpers.isDisabled()
  }, on: {
    click: this.helpers.isDisabled() ? null : this.helpers.handleClick
  }, "data-sentry-element": "SharingStatusButtonEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" });
}
